/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Workflow { 
    id?: string;
    name?: string;
    code?: string;
    publish_date?: Date;
    process_number?: string;
    appover_id?: string;
    approved?: boolean;
    deleted?: boolean;
    enabled?: boolean;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    workflow_tree_node_id?: string;
    description?: string;
    hidden?: boolean;
}